<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>서비스 이용 방법</div>
    </div>
    <div class="card-body top" *ngIf="way">
      <div class="content">{{ way }}</div>
    </div>
  </div>
</div>
